import "./Fire.css";

function DeadFire() {
  return (
    <div className="content">
      <div className="wood">
        <div className="stick"></div>
        <div className="stick"></div>
        <div className="stick"></div>
      </div>
    </div>
  );
}

export default DeadFire;
